// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"d67b8630","127":"59d5ef94","141":"585caf39","268":"b60dc9c4","788":"d6aa4b56"}[chunkId] + ".chunk.css";
};